import { render, staticRenderFns } from "./index.vue?vue&type=template&id=241f7cd4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=241f7cd4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241f7cd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/dev-official-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('241f7cd4')) {
      api.createRecord('241f7cd4', component.options)
    } else {
      api.reload('241f7cd4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=241f7cd4&scoped=true", function () {
      api.rerender('241f7cd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Register/index.vue"
export default component.exports